import { jsx as _jsx } from "react/jsx-runtime";
import { TableRow } from "../table-row/TableRow";
import { ExpandableRow } from "../expandable-row/ExpandableRow";
import { TableCell } from "../table-cell/TableCell";
export const TableBody = ({ bodyData = [], sortMethod }) => {
    const sortedBodyData = sortMethod ? bodyData.sort(sortMethod) : bodyData;
    return (_jsx("tbody", { children: sortedBodyData.map((row, rowIndex) => {
            if (!row.id) {
                row.id = `row-${rowIndex}`;
            }
            const RowComponent = row.component || (row.nestedRows ? ExpandableRow : TableRow);
            return (_jsx(RowComponent, { ...row, children: row.cells &&
                    row.cells.map(({ children, ...cell }, cellIndex) => {
                        if (!cell.id) {
                            cell.id = `${row.id}-cell-${cellIndex}`;
                        }
                        const CellComponent = cell.component ? cell.component : TableCell;
                        return (_jsx(CellComponent, { ...cell, children: children }, cell.id));
                    }) }, row.id));
        }) }));
};
